import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/mobile.css';
import './styles/united-operations.css';
// The standalone synthetic build never loads App/AuthContext/Firebase.
const App = React.lazy(() => process.env.REACT_APP_ASSISTANT_DEMO === 'true'
  ? process.env.REACT_APP_ASSISTANT_AGENT_DEMO === 'true' ? import('./assistant/AgentPanelDemo') : import('./assistant/DemoApp')
  : import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<p dir="rtl">جارٍ التحميل…</p>}><App /></React.Suspense>
  </React.StrictMode>
);
